import { Helmet } from "react-helmet-async";
import Sidebar from "../../../frontend/DesignSystem/Sidebar";
import "../../../css/LOA/LOA.css";
import { useSearchParams } from "react-router-dom";
import CedingSchemePage from "./CedingScheme/CedingSchemePage";

export const LOA = () => {
  const [searchParams] = useSearchParams();

  const extractionId = searchParams.get("extractionId");
  const ownerEmail = searchParams.get("ownerEmail");

  return (
    <div className="loa-content">
      <Helmet>
        <title>ProCeding</title>
        <meta
          name="description"
          content="Rosemount Financial Solutions (IFA) Ltd - Adviser Portal"
        />
      </Helmet>

      <Sidebar />

      <main className="loa-main">
        <CedingSchemePage extractionId={extractionId} ownerEmail={ownerEmail} />
      </main>
    </div>
  );
};
